import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import { fieldProps, getPreferredProp } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ToggleField(_ref) {
  let {
    disabled = false,
    fullWidth = false,
    hint = "",
    id,
    label = "",
    valuePosition = "right",
    style = {
      container: "",
      button: "",
      hint: "",
      label: "",
      toggle: "",
      wrapper: ""
    },
    value,
    valueText = "",
    ...props
  } = _ref;
  const containerClass = cn('space-x-2', {
    'w-full': fullWidth,
    'inline-flex items-center': !hint,
    flex: hint
  }, style.container);
  const labelClass = cn('normal-case text-sm text-text-blue font-regular-font tracking-normal', {
    'w-1/2': fullWidth,
    'mt-0.5': hint
  }, style.label);
  const buttonClass = cn('w-10 h-6 rounded-xl transition-all duration-500 focus:outline-solid-offset', {
    'bg-action-blue border-action-blue': value,
    'hover:bg-deep-blue': value && !disabled,
    'bg-medium-grey border-medium-grey': !value,
    'hover:bg-dark-grey': !value && !disabled,
    'bg-opacity-50 cursor-default': disabled
  }, style.button);
  const spanClass = cn('inline-block h-6 w-6 bg-white border-solid border-2 rounded-xl', {
    'transform translate-x-2 border-action-blue': value,
    'hover:border-deep-blue': value && !disabled,
    'transform -translate-x-2 border-medium-grey': !value,
    'hover:border-dark-grey': !value && !disabled,
    'border-opacity-50': disabled
  });
  const toggleClass = cn('flex items-center', {
    'flex-row-reverse justify-end': valuePosition === 'left'
  }, style.toggle);
  const valueTextClass = cn('text-sm', {
    'pr-2': valuePosition === 'left',
    'pl-2': valuePosition === 'right',
    'opacity-50': disabled
  });
  const hintClass = cn('text-xs italic leading-4 pt-2 text-medium-grey', {
    'opacity-50': disabled
  }, style.hint);
  return /*#__PURE__*/_jsxs("div", {
    className: containerClass,
    "data-testid": `${id}-toggle-field__wrapper`,
    id: `${id}-toggle-field__wrapper`,
    children: [label && /*#__PURE__*/_jsx("label", {
      className: labelClass,
      htmlFor: `${id}-toggle-field__button`,
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: `${fullWidth ? "w-1/2" : ""} ${style.wrapper}`,
      children: [/*#__PURE__*/_jsxs("div", {
        className: toggleClass,
        children: [/*#__PURE__*/_jsxs("button", {
          className: buttonClass,
          "data-testid": `${id}-toggle-field__button`,
          id: `${id}-toggle-field__button`,
          onClick: getPreferredProp(props, "onClick"),
          onBlur: getPreferredProp(props, "onBlur"),
          onFocus: getPreferredProp(props, "onFocus"),
          tabIndex: 0,
          disabled: disabled,
          type: "button",
          children: [/*#__PURE__*/_jsx("span", {
            className: "sr-only",
            children: `${label} toggle: ${valueText}`
          }), hint && /*#__PURE__*/_jsx("span", {
            className: "sr-only",
            children: `toggle hint: ${hint}`
          }), /*#__PURE__*/_jsx("span", {
            className: spanClass
          })]
        }), valueText && /*#__PURE__*/_jsx("div", {
          className: valueTextClass,
          children: valueText
        })]
      }), hint && /*#__PURE__*/_jsx("div", {
        className: hintClass,
        "data-testid": `${id}-toggle-field__hint`,
        id: `${id}-toggle-field__hint`,
        children: hint
      })]
    })]
  });
}
ToggleField.propTypes = {
  /** Is the field disabled? */
  disabled: PropTypes.bool,
  /** Should the field span the full width of the page? */
  fullWidth: PropTypes.bool,
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** Help text displayed below the button */
  hint: PropTypes.string,
  /** label text for toggle field */
  label: PropTypes.string,
  /** Position of the label */
  valuePosition: PropTypes.oneOf(["right", "left"]),
  /** Add tailwind styles to elements */
  style: PropTypes.shape({
    container: PropTypes.string,
    button: PropTypes.string,
    hint: PropTypes.string,
    label: PropTypes.string,
    toggle: PropTypes.string,
    wrapper: PropTypes.string
  }),
  /** Value of the toggle (ex: true/false) */
  value: PropTypes.bool.isRequired,
  /** Text displayed to the left or right of button */
  valueText: PropTypes.string,
  /** See fieldProps doc */
  ...fieldProps
};
export default ToggleField;
//# sourceMappingURL=ToggleField.js.map